import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import arrowOutwardWhite2 from "@/assets/images/user/arrowOutwardWhite2.svg";
import icInstagram from "@/assets/images/user/icInstagram.svg";
import icPlus from "@/assets/images/user/icPlus.svg";
import logo1box1 from "@/assets/images/user/logo1box1.png";
import logo2box1 from "@/assets/images/user/logo2box1.png";
import logo2box2 from "@/assets/images/user/logo2box2.png";
// import logo3box1 from "@/assets/images/user/logo3box1.png";
// import logo3box2 from "@/assets/images/user/logo3box2.png";
// import logo3box3 from "@/assets/images/user/logo3box3.png";
// import logo3box4 from "@/assets/images/user/logo3box4.png";
// import logo3box5 from "@/assets/images/user/logo3box5.png";
// import logo3box6 from "@/assets/images/user/logo3box6.png";
// import logo3box7 from "@/assets/images/user/logo3box7.png";
// import logo3box8 from "@/assets/images/user/logo3box8.png";
// import logo3box9 from "@/assets/images/user/logo3box9.png";
// import logo3box10 from "@/assets/images/user/logo3box10.png";
// import logo3box11 from "@/assets/images/user/logo3box11.png";
// import logo3box12 from "@/assets/images/user/logo3box12.png";
// import logo3box13 from "@/assets/images/user/logo3box13.png";
// import logo3box14 from "@/assets/images/user/logo3box14.png";
// import logo3box15 from "@/assets/images/user/logo3box15.png";
// import logo4box1 from "@/assets/images/user/logo4box1.png";
// import logo4box2 from "@/assets/images/user/logo4box2.png";
// import logo4box3 from "@/assets/images/user/logo4box3.png";
// import logo4box4 from "@/assets/images/user/logo4box4.png";
// import logo4box5 from "@/assets/images/user/logo4box5.png";
// import logo4box6 from "@/assets/images/user/logo4box6.png";
// import logo4box7 from "@/assets/images/user/logo4box7.png";
// import logo4box8 from "@/assets/images/user/logo4box8.png";
// import logo4box9 from "@/assets/images/user/logo4box9.png";
// import logo4box10 from "@/assets/images/user/logo4box10.png";
// import logo4box11 from "@/assets/images/user/logo4box11.png";
// import logo4box12 from "@/assets/images/user/logo4box12.png";
// import logo4box13 from "@/assets/images/user/logo4box13.png";
// import logo4box14 from "@/assets/images/user/logo4box14.png";
// import logo4box15 from "@/assets/images/user/logo4box15.png";
// import logo4box16 from "@/assets/images/user/logo4box16.png";
// import logo4box17 from "@/assets/images/user/logo4box17.png";
// import logo4box18 from "@/assets/images/user/logo4box18.png";
// import logo4box19 from "@/assets/images/user/logo4box19.png";
// import logo4box20 from "@/assets/images/user/logo4box20.png";
// import logo5box1 from "@/assets/images/user/logo5box1.png";
// import logo5box2 from "@/assets/images/user/logo5box2.png";
// import logo5box3 from "@/assets/images/user/logo5box3.png";
// import logo5box4 from "@/assets/images/user/logo5box4.png";
// import logo6box1 from "@/assets/images/user/logo6box1.png";
// import logo6box2 from "@/assets/images/user/logo6box2.png";
// import logo6box3 from "@/assets/images/user/logo6box3.png";
// import logo6box4 from "@/assets/images/user/logo6box4.png";
// import logo6box5 from "@/assets/images/user/logo6box5.png";
// import logo6box6 from "@/assets/images/user/logo6box6.png";
// import logo6box7 from "@/assets/images/user/logo6box7.png";
// import logo6box8 from "@/assets/images/user/logo6box8.png";
// import logo7box1 from "@/assets/images/user/logo7box1.png";
// import logo7box2 from "@/assets/images/user/logo7box2.png";
import mainLineBox from "@/assets/images/user/mainLineBox.svg";
import mainVideo from "@/assets/images/user/mainVideo.mp4";
import txtQuotes from "@/assets/images/user/txtQuotes.svg";
import LoadingSpinner from "@/components/common/common/LoadingSpinner";
import SubTitle from "@/components/user/common/SubTitle";
import UserPop from "@/components/user/popup/UserPop";
import { useGetInstagramList } from "@/service/user/main";

const logoList = [
    {
        title: "주 최",
        logos: [
            {
                src: logo1box1,
                alt: "성남시",
            },
        ],
    },
    {
        title: "주 관",
        logos: [
            {
                src: logo2box1,
                alt: "성남산업진흥원",
            },
            {
                src: logo2box2,
                alt: "게임문화재단",
            },
        ],
    },
    // {
    //     title: "후 원",
    //     logos: [
    //         {
    //             src: logo3box1,
    //             alt: "문화체육관광부",
    //         },
    //         {
    //             src: logo3box2,
    //             alt: "한국콘텐츠진흥원",
    //         },
    //         {
    //             src: logo3box3,
    //             alt: "게임물관리위원회",
    //         },
    //         {
    //             src: logo3box4,
    //             alt: "경기도",
    //         },
    //         {
    //             src: logo3box5,
    //             alt: "경기관광공사",
    //         },
    //         {
    //             src: logo3box6,
    //             alt: "성남시청소년청년재단",
    //         },
    //         {
    //             src: logo3box7,
    //             alt: "넥슨코리아",
    //         },
    //         {
    //             src: logo3box8,
    //             alt: "엔씨소프트",
    //         },
    //         {
    //             src: logo3box9,
    //             alt: "호요버스",
    //         },
    //         {
    //             src: logo3box10,
    //             alt: "슈퍼셀",
    //         },
    //         {
    //             src: logo3box11,
    //             alt: "펄어비스",
    //         },
    //         {
    //             src: logo3box12,
    //             alt: "레드프린팅",
    //         },
    //         {
    //             src: logo3box13,
    //             alt: "동아오츠카",
    //         },
    //         {
    //             src: logo3box14,
    //             alt: "마이크로소프트",
    //         },
    //         {
    //             src: logo3box15,
    //             alt: "클라우디드 레오파드 엔터테인먼트코리아",
    //         },
    //     ],
    // },
    // {
    //     title: "협 찬",
    //     logos: [
    //         {
    //             src: logo4box1,
    //             alt: "굴뚝강아지",
    //         },
    //         {
    //             src: logo4box2,
    //             alt: "그래비티 조선 서울 판교",
    //         },
    //         {
    //             src: logo4box3,
    //             alt: "그레이츠 판교",
    //         },
    //         {
    //             src: logo4box4,
    //             alt: "네오위즈",
    //         },
    //         {
    //             src: logo4box5,
    //             alt: "데브시스터즈",
    //         },
    //         {
    //             src: logo4box6,
    //             alt: "성남게임힐링센터",
    //         },
    //         {
    //             src: logo4box7,
    //             alt: "스마일게이트",
    //         },
    //         {
    //             src: logo4box8,
    //             alt: "스타라이크",
    //         },
    //         {
    //             src: logo4box9,
    //             alt: "알파돔 타워",
    //         },
    //         {
    //             src: logo4box10,
    //             alt: "에피드게임즈",
    //         },
    //         {
    //             src: logo4box11,
    //             alt: "NHN",
    //         },
    //         {
    //             src: logo4box12,
    //             alt: "위메이드",
    //         },
    //         {
    //             src: logo4box13,
    //             alt: "카카오게임즈",
    //         },
    //         {
    //             src: logo4box14,
    //             alt: "카카오 아지트",
    //         },
    //         {
    //             src: logo4box15,
    //             alt: "크래프톤",
    //         },
    //         {
    //             src: logo4box16,
    //             alt: "판교 테크원",
    //         },
    //         {
    //             src: logo4box17,
    //             alt: "2K",
    //         },
    //         {
    //             src: logo4box18,
    //             alt: "플러디",
    //         },
    //         {
    //             src: logo4box19,
    //             alt: "한국모바일게임협회",
    //         },
    //         {
    //             src: logo4box20,
    //             alt: "한림사",
    //         },
    //     ],
    // },
    // {
    //     title: "참가 기관·기업",
    //     logos: [
    //         {
    //             src: logo6box1,
    //             alt: "동서울대학교",
    //         },
    //         {
    //             src: logo6box2,
    //             alt: "매직빈게임즈",
    //         },
    //         {
    //             src: logo6box3,
    //             alt: "바다",
    //         },
    //         {
    //             src: logo6box4,
    //             alt: "SYLO",
    //         },
    //         {
    //             src: logo6box5,
    //             alt: "신구대학교 게임콘텐츠과",
    //         },
    //         {
    //             src: logo6box6,
    //             alt: "오렌지커뮤니케이션즈",
    //         },
    //         {
    //             src: logo6box7,
    //             alt: "창조공작소",
    //         },
    //         {
    //             src: logo6box8,
    //             alt: "플래직",
    //         },
    //     ],
    // },
    // {
    //     title: "콜라보레이션",
    //     logos: [
    //         {
    //             src: logo5box1,
    //             alt: "인디크래프트",
    //         },
    //         {
    //             src: logo5box2,
    //             alt: "일러스타 페스",
    //         },
    //         {
    //             src: logo5box3,
    //             alt: "성남청년 플리마켓",
    //         },
    //         {
    //             src: logo5box4,
    //             alt: "GV2025",
    //         },
    //     ],
    // },
    // {
    //     title: "브랜드 파트너",
    //     logos: [
    //         {
    //             src: logo7box1,
    //             alt: "젠레스 존 제로",
    //         },
    //         {
    //             src: logo7box2,
    //             alt: "브롤스타즈",
    //         },
    //     ],
    // },
];

export default function Main() {
    // const [day, setDay] = useState("");
    const sect2Ref = useRef<HTMLDivElement>(null);
    const sect3Ref = useRef<HTMLDivElement>(null);
    const [sect2On, setSect2On] = useState(false);
    const [sect3On, setSect3On] = useState(false);
    const [instaImgList, setInstaImgList] = useState<
        { media_url: string; thumbnail_url: string | null; permalink: string }[]
    >([]);
    const { data: configData, isLoading: isInitialLoading } = useGetInstagramList(1, 12);

    // 인스타그램 리스트 조회
    useEffect(() => {
        if (configData?.data?.posts) {
            setInstaImgList(configData.data.posts);
        } else {
            setInstaImgList([]);
        }
    }, [configData]);

    // 날짜 계산
    // useEffect(() => {
    //     const today = new Date();
    //     const targetDate = new Date("2025-09-19");

    //     // 날짜 비교를 위해 시간을 00:00:00으로 설정
    //     today.setHours(0, 0, 0, 0);
    //     targetDate.setHours(0, 0, 0, 0);

    //     const difference = targetDate.getTime() - today.getTime();
    //     const daysRemaining = Math.ceil(difference / (1000 * 3600 * 24));

    //     let displayText;
    //     // 목표날짜일때만 D-Day 표시
    //     if (daysRemaining === 0 || daysRemaining === 1) {
    //         displayText = "D-Day";
    //     } else {
    //         const prefix = daysRemaining >= 0 ? "D-" : "D+";
    //         displayText = `${prefix}${Math.abs(daysRemaining)}`;
    //     }

    //     setDay(displayText);
    // }, []);

    //스크롤시 section on
    const scrollSectOn = () => {
        const scroll = window.scrollY;
        const sections: {
            ref: React.RefObject<HTMLDivElement>;
            onSet: React.Dispatch<React.SetStateAction<boolean>>;
        }[] = [
            { ref: sect2Ref, onSet: setSect2On },
            { ref: sect3Ref, onSet: setSect3On },
        ];

        sections.forEach(({ ref, onSet }) => {
            if (ref.current) {
                const offsetTop = ref.current.offsetTop;
                if (scroll >= offsetTop - 600) {
                    onSet(true);
                }
            }
        });
    };

    useEffect(() => {
        window.addEventListener("scroll", scrollSectOn);

        return () => {
            window.removeEventListener("scroll", scrollSectOn);
        };
    }, []);

    return (
        <>
            <section className="h-[100vh] relative block min-h-[500px] overflow-hidden">
                <div className="h-full px-[24px] relative after:absolute after:left-0 after:-bottom-[1px] after:size-[70px] after:border-[35px] after:border-white after:border-t-transparent after:border-r-transparent after:z-[20] md:px-[40px] xl:px-0">
                    <div className="relative h-full max-w-[1600px] w-full mx-auto before:hidden before:absolute before:left-0 before:top-0 before:w-[1px] before:h-full before:bg-[rgba(221,221,221,0.6)] before:z-[12] md:before:block">
                        <div className="h-full flex flex-col justify-center relative z-[20] gap-[14%] before:hidden before:absolute before:left-1/2 before:bottom-[13%] before:-translate-x-1/2 before:w-[100vw] before:h-[1px] before:bg-[rgba(221,221,221,0.6)] before:z-[12] md:before:block md:gap-[5%] xl:flex-col-reverse xl:gap-0">
                            <div className="relative left-0 top-0 font-['GongGothicMedium'] text-[50px] opacity-0 animate-slide-in-from-left [animation-delay:500ms] md:text-[80px] md:pl-[40px] md:-top-[60px] xl:text-[100px] xl:pl-[100px] xl:-top-[100px]">
                                <img src={txtQuotes} alt="따옴표" className="w-[44px] md:w-auto" />
                                <p className="text-[72px] text-white leading-[1.3] md:text-[120px] xl:text-[140px]">
                                    게임,
                                </p>
                                <p>
                                    <span className="text-white">문화</span>
                                    <span className="text-stroke-1-white text-transparent">로 즐기다</span>
                                    <span className="text-primary">.</span>
                                </p>
                            </div>
                            {/* <div className="flex justify-end font-[500] font-['GongGothicMedium'] opacity-0 animate-fade-in [animation-delay:500ms]">
                                <div className="relative text-right">
                                    <div className="relative flex flex-col leading-[1.5] text-[18px] font-[500] text-white pb-[5px] md:flex-row md:justify-between xl:text-[20px]">
                                        <p>2025.09.19 ~ 2025.09.20</p>
                                        <p>2days</p>
                                    </div>
                                    <p className="text-stroke-1-white text-transparent text-[80px] font-[500] relative leading-[1.2] after:absolute after:left-0 after:bottom-0 after:w-[60px] after:h-[4px] after:bg-primary md:text-[140px] md:after:w-[120px] md:after:h-[8px] xl:text-[180px]">
                                        {day}
                                    </p>
                                </div>
                            </div> */}
                            <img
                                src={mainLineBox}
                                alt="이미지"
                                className="absolute left-0 bottom-[13%] -translate-x-1/2 translate-y-1/2 z-[21] hidden md:block"
                            />
                        </div>
                    </div>
                    <div className="absolute inset-0 w-full h-full after:absolute after:inset-0 after:bg-[rgba(0,0,0,0.4)] after:w-full after:h-full animate-zoom-in">
                        <video src={mainVideo} autoPlay muted loop playsInline className="w-full h-full object-cover" />
                    </div>
                </div>
            </section>
            <section className="pt-[80px] xl:pt-[160px]" ref={sect2Ref}>
                <div
                    className={`px-[20px] max-w-[1400px] w-full mx-auto opacity-0 xl:px-0${sect2On ? " animate-slide-in-from-bottom [animation-delay:250ms]" : ""}`}
                >
                    <div className="flex flex-col items-center gap-[16px] md:items-start xl:flex-row xl:justify-between xl:items-center">
                        <SubTitle title="INSTAGRAM UPDATE" />
                        <Link
                            to="https://www.instagram.com/gxg_gameculture/"
                            target="_blank"
                            className="flex items-center gap-[8px] text-[14px] text-[#666] font-['GongGothicLight'] h-[30px] px-[16px] shadow-[0_0_4px_rgba(124,101,219,0.20)] rounded-[20px]"
                        >
                            <img src={icInstagram} alt="인스타그램" />
                            <span>gxg_gameculture</span>
                        </Link>
                    </div>
                    {isInitialLoading ? (
                        <div className="flex justify-center items-center h-[300px]">
                            <LoadingSpinner />
                        </div>
                    ) : (
                        <>
                            <ul className="p-[40px_0_20px] grid grid-cols-2 gap-[8px] md:p-[60px_0_24px] md:grid-cols-3 md:gap-[14px] xl:grid-cols-4 xl:gap-[12px]">
                                {instaImgList.map((item, index) => {
                                    return (
                                        <li
                                            key={`instagram_${index}`}
                                            className="relative rounded-[8px] overflow-hidden h-0 pb-[130%] group"
                                        >
                                            <a
                                                href={item.permalink}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="block absolute inset-0 w-full h-full"
                                            >
                                                <img
                                                    src={item.thumbnail_url || item.media_url}
                                                    alt="인스타그램 이미지"
                                                    className="absolute inset-0 w-full h-full object-cover group-hover:scale-[1.2] transition-all duration-500"
                                                />
                                                <div className="absolute inset-0 flex items-center justify-center bg-[rgba(0,0,0,0.4)] opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                                    <img src={arrowOutwardWhite2} alt="화살표" />
                                                </div>
                                            </a>
                                        </li>
                                    );
                                })}
                            </ul>
                            <Link
                                to="https://www.instagram.com/gxg_gameculture/"
                                target="_blank"
                                className="flex items-center justify-center gap-[12px] text-[18px] text-[#666] font-['GongGothicLight'] h-[53px] rounded-[8px] w-full bg-[#F1F4F9]"
                            >
                                More
                                <img src={icPlus} alt="더보기" />
                            </Link>
                        </>
                    )}
                </div>
            </section>
            <section className="p-[80px_0_120px] xl:p-[160px_0]" ref={sect3Ref}>
                <ul
                    className={`px-[20px] max-w-[1400px] w-full mx-auto flex flex-col gap-[50px] opacity-0 xl:px-0 xl:flex-wrap xl:flex-row xl:gap-x-[32px] xl:gap-y-[60px]${sect3On ? " animate-slide-in-from-bottom [animation-delay:250ms]" : ""}`}
                >
                    {logoList.map((item, index) => (
                        <li
                            key={`logoBox_${index}`}
                            className={`p-[4px] ${index > 1 ? "w-full" : "xl:w-[calc(50%-16px)]"}`}
                        >
                            <div className="relative p-[10px] border border-[rgba(221,221,221,0.6)] before:absolute before:-left-[1px] before:top-[8px] before:w-[4px] before:h-[32px] before:bg-primary before:-translate-x-full after:absolute after:left-[7px] after:-top-[1px] after:w-[32px] after:h-[4px] after:bg-primary after:-translate-y-full">
                                <div
                                    className={`p-[30px_20px_40px] flex flex-col items-center gap-[35px] relative before:absolute before:-right-[11px] before:-bottom-[1px] before:w-[4px] before:h-[32px] before:bg-primary before:translate-x-full after:absolute after:-right-[2px] after:-bottom-[11px] after:w-[32px] after:h-[4px] after:bg-primary after:translate-y-full md:p-[30px_60px] xl:p-[40px_50px] ${index > 1 ? "md:items-start md:gap-[40px]" : "md:flex-row md:gap-0"}`}
                                >
                                    <p
                                        className={`text-[24px] font-[700] text-black font-['GongGothicMedium'] md:text-[32px]${index < 2 ? " md:w-[180px]" : ""}`}
                                    >
                                        {item.title}
                                    </p>
                                    <ul
                                        className={`w-full flex items-center gap-[24px] ${index > 1 ? "flex-wrap md:gap-[40px] xl:gap-y-[40px]" : "justify-center md:flex-1 md:justify-start md:gap-x-[60px]"} ${index === 2 || index === 3 ? "xl:grid xl:grid-cols-5 xl:gap-x-[115px]" : index > 3 ? "xl:gap-x-[120px] xl:justify-center" : ""}`}
                                    >
                                        {item.logos.map((logo, logoIndex) => (
                                            <li
                                                key={`logo_${logoIndex}`}
                                                className={`w-[calc(50%-12px)] ${index > 1 ? "md:w-[calc(33.333%-26.666px)] xl:w-auto" : "md:w-[calc(50%-30px)]"}`}
                                            >
                                                <img src={logo.src} alt={logo.alt} className="mx-auto" />
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            </section>
            <UserPop />
        </>
    );
}
